import React from "react";

const HomeServicesBody = () => {
  return (
    <div className="__sweven_home-services--body">
      <div className="__sweven_home-services--body__description">
        We have been working on for produce our product to make easier world
        with digital ink. We don't just sell websites, we create websites that
        SELL. We meet the needs of companies with complex websites in
        competitive industries.
      </div>
    </div>
  );
};

export default HomeServicesBody;
